<template lang="html">
<div>
  <toolbar title="User Profile">
  </toolbar>
  <v-layout column>

    <v-layout column class="mt-2">
      <v-card class="py-3 pl-5">
        <v-tabs color="white" show-arrows>
          <v-tab key="contactInfo" to="#contact">
            Contact Info
          </v-tab>
          <v-tab key="bqa" to="#bqa">
            BQA Certificate
          </v-tab>
          <v-tab key="cdlInfo" to="#cdl">
            CDL Info
          </v-tab>
          <v-tabs-items>
            <v-tab-item value="contact" lazy>
              <v-layout align-baseline>
                <div class="title mr-3 py-4">
                  Contact info
                </div>
              </v-layout>
              <v-layout column sm6>
                <v-layout>
                  <v-flex sm3 class="mr-5">
                    <v-text-field :readonly="isNonceUser"  label="Full Name" v-model="name"/>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex sm3 class="mr-5">
                    <v-text-field disabled label="Account Email" v-model="contactEmail"/>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex sm3 class="mr-5">
                    <v-text-field :readonly="isNonceUser" label="Contact Phone" v-model="contactPhone"/>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex sm4 class="mr-5">
                    <v-textarea :readonly="isNonceUser" label="Brief Bio" v-model="briefBio"/>
                  </v-flex>
                </v-layout>

                <v-layout v-if="!isNonceUser">
                  <v-flex sm3 class="mr-5">
                    <v-btn class="accent"
                           :loading="loadingBtn"
                           @click="saveContactInfo">Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-tab-item>
            <v-tab-item value="bqa" lazy>
              <v-layout align-baseline>
                <div class="title mr-3 py-4">
                  BQA  <bqa-certificate-icon :driver="userInfo"></bqa-certificate-icon>
                </div>
                <span sm3 class="pl-2 mr5"></span>
              </v-layout>
              <v-layout column>
                <v-layout>
                  <v-flex sm6>
                    <v-text-field v-model="bqaId" label="BQA Id"></v-text-field>
                    <upload-button class="cursor-pointer" label="Certificate"
                                   v-model="bqaFile" @files="bpaFileUpload" />

                    <v-menu
                      ref="bqaExpiresDateMenu"
                      :close-on-content-click="false"
                      v-model="bqaExpiresDateMenu"
                      :nudge-right="40"
                      :return-value.sync="expires"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      :disabled="isNonceUser"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="expires"
                        label="BQA Expires"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="expires" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary"
                               @click="bqaExpiresDateMenu = false">Cancel</v-btn>
                        <v-btn flat color="primary"
                               @click="$refs.bqaExpiresDateMenu.save(expires)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>

                    <v-btn flat
                           v-if="documentUri"
                           @click="openBqaCertificate()">
                      Open certificate
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout v-if="!isNonceUser">
                  <v-flex sm3 class="mr-5">
                    <v-btn class="accent"
                           :disabled="!bqaFileData || !expires"
                           :loading="loadingBtn"
                           @click="saveBQA">Save</v-btn>
                    <v-btn color="primary"
                           class="ml-3"
                           v-if="isLtnAdmin && !verified"
                           :disabled="!expires"
                           @click="verifyBqa"
                           :loading="loadingBtn">
                      Verify
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-tab-item>
            <v-tab-item value="cdl" lazy>
              <v-layout align-baseline>
                <div class="title mr-3 py-4">
                  CDL Info
                </div>
                <span v-if="!isNonceUser" sm3 class="pl-2 mr5">
                  Add your CDL information to your Profile so loads can be assigned to you.
                </span>
              </v-layout>
              <v-layout v-if="showDriverProfileSection">
                <v-layout column sm6>
                  <v-layout>
                    <v-flex sm3 class="mr-5">
                      <v-menu
                        ref="cdlExpiresDateMenu"
                        :close-on-content-click="false"
                        v-model="cdlExpiresDateMenu"
                        :nudge-right="40"
                        :return-value.sync="cdlExpires"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        :disabled="isNonceUser"
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="cdlExpires"
                          label="CDL Expires"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker v-model="cdlExpires" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="cdlExpiresDateMenu = false">Cancel</v-btn>
                          <v-btn flat color="primary"  @click="$refs.cdlExpiresDateMenu.save(cdlExpires)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex sm3 class="mr-5">
                      <v-menu
                        ref="medicalExpiresDateMenu"
                        :close-on-content-click="false"
                        v-model="medicalExpiresDateMenu"
                        :nudge-right="40"
                        :return-value.sync="medicalExpires"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        :disabled="isNonceUser"
                        min-width="290px">
                        <v-text-field
                          slot="activator"
                          v-model="medicalExpires"
                          label="Medical Expires"
                          prepend-icon="event"
                          readonly></v-text-field>
                        <v-date-picker v-model="medicalExpires" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary"
                                 @click="medicalExpiresDateMenu = false">Cancel</v-btn>
                          <v-btn flat color="primary"
                                 @click="$refs.medicalExpiresDateMenu.save(medicalExpires)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="!isNonceUser">
                    <v-flex sm3 class="mr-5">
                      <v-btn class="accent" :loading="loadingBtn"
                             @click="saveCDL">Save
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-layout v-else>
                <v-btn v-if="!isNonceUser" class="accent" @click="showDriverProfile = true">
                  <v-icon class="mr-2">add_circle</v-icon>
                  Add CDL Details
                </v-btn>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-layout>

    <v-layout column class="mt-2"
              v-if="userProfile.companyAccounts && userProfile.companyAccounts.length">
      <v-card class="pt-2 pb-4 pl-5 pr-5 mt-3">
        <v-layout align-baseline>
          <div class="title mr-3 mt-4 py-4">
            Company Permissions
          </div>
        </v-layout>
        <v-layout column sm6>
          <v-layout column>
            <v-layout column class="mt-3">
              <v-layout>
                <v-flex sm2 class="secondary--text">Company</v-flex>
                <v-flex sm2 class="secondary--text">Phone</v-flex>
                <v-flex sm2 class="secondary--text">Email</v-flex>
                <v-flex sm3 class="secondary--text">Permissions</v-flex>
              </v-layout>
              <v-divider class="my-1" />
              <template v-for="(companyAccount, index) in userProfile.companyAccounts">
                <v-layout :key="index">
                  <v-flex sm2 class="cursor-pointer"
                          @click="viewCompanyProfile(companyAccount.companyId)">
                    {{companyAccount.companyDisplayName}}</v-flex>
                  <v-flex sm3>{{companyAccount.contactPhone}} </v-flex>
                  <v-flex sm3>{{companyAccount.contactEmail}} </v-flex>
                  <v-flex sm3>
                    {{companyAccount.companyPermissions ?
                    companyAccount.companyPermissions.join(', ') : null}}
                  </v-flex>
                </v-layout>
                <v-divider class="my-1" :key="'div_'+index" />
              </template>

            </v-layout>
          </v-layout>
        </v-layout>
      </v-card>
    </v-layout>

  </v-layout>
  </div>
</template>

<script>
import _ from 'lodash';
import { createHelpers } from 'vuex-map-fields';
import { mapState, mapGetters } from 'vuex';
import API from '@/api';
import Toolbar from '@/components/Toolbar';
import UploadButton from '@/components/UploadButton';
import BqaCertificateIcon from '../../components/BqaCertificateIcon';

const { mapFields } = createHelpers({
  getterType: 'profiles/getField',
  mutationType: 'profiles/updateField',
});

export default {
  name: 'Profile',
  components: {
    BqaCertificateIcon,
    Toolbar,
    UploadButton,
  },
  computed: {
    ...mapState('profiles', {
      userInfo: 'userInfo',
      userProfile: 'userProfile',
    }),
    ...mapState('profiles', {
      userInfo: 'userInfo',
      userProfile: 'userProfile',
    }),
    ...mapGetters('applications', [
      'isNonceUser',
    ]),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapFields([
      'userInfo.name',
      'userInfo.contactEmail',
      'userInfo.contactPhone',
      'userInfo.briefBio',
      'userInfo.driverProfile.cdlExpires',
      'userInfo.driverProfile.medicalExpires',
      'userInfo.bqaCertification.bqaId',
      'userInfo.bqaCertification.documentUri',
      'userInfo.bqaCertification.expires',
      'userInfo.bqaCertification.verified',
    ]),
    showDriverProfileSection() {
      return this.showDriverProfile || _.get(this.userInfo, 'driverProfile.medicalExpires');
    },
    userId() {
      return this.$route.params.userId;
    },
  },
  data: () => ({
    medicalExpiresDateMenu: false,
    cdlExpiresDateMenu: false,
    bqaExpiresDateMenu: false,
    showDriverProfile: false,
    loadingBtn: false,
    bqaFileData: null,
    bqaFile: null,
  }),
  methods: {
    openBqaCertificate() {
      this.$store.dispatch('lightbox/show', this.userInfo.bqaCertification.documentUri);
    },
    async verifyBqa() {
      try {
        this.loadingBtn = true;
        await API.user.verifyBqaProfile(this.userInfo.authProviderId);
        this.$store.dispatch('profiles/getUser', { userId: this.userId });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    bpaFileUpload(file) {
      this.bqaFileData = file[0];
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async saveBQA() {
      try {
        this.loadingBtn = true;
        if (this.bqaFileData) {
          const base64File = await this.getBase64(this.bqaFileData);
          const bqaProfile = {
            bqaId: this.bqaId,
            certification: {
              documentName: this.bqaFile,
              pages: [{
                base64EncodedData: base64File,
              }],
            },
            userAuthId: this.userInfo.authProviderId,
            expires: this.expires,
          };

          await API.user.updateUserBqaInfo({ bqaProfile });
          this.$store.dispatch('profiles/getUser', { userId: this.userId });
        }
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    async saveCDL() {
      try {
        this.loadingBtn = true;
        const userCDL = {
          cdlExpires: this.userInfo.driverProfile.cdlExpires || '',
          medicalExpires: this.userInfo.driverProfile.medicalExpires || '',
          userAuthId: this.userInfo.authProviderId,
        };

        await API.user.updateCDLInfo({ userCDL });
        this.$store.dispatch('profiles/getUser', { userId: this.userId });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'User updated',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    async saveContactInfo() {
      const user = {
        briefBio: this.userInfo.briefBio || '',
        contactEmail: this.userInfo.contactEmail || '',
        contactPhone: this.userInfo.contactPhone || '',
        displayName: this.userInfo.name,
        profileImageUrl: '',
        userAuthId: this.userInfo.authProviderId,
      };

      if (!this.userInfo.contactPhone) {
        const response = await API.user.getMyNotificationSettings();
        // Check if has sms notifications
        const settings = response.data;
        const withAlerts = _.pickBy(settings, val => val.sms);

        const hasSmsAlerts = !_.isEmpty(withAlerts);

        let confirmation;
        if (hasSmsAlerts) {
          Object.keys(withAlerts).forEach((key) => {
            withAlerts[key].sms = false;
          });

          confirmation = await this.$confirm('Do you really want to remove your Contact Phone and cancel all sms notifications?');

          if (confirmation) {
            this.loadingBtn = true;
            await API.user.updateMyNotificationSettings({ settings });
            this.loadingBtn = false;
          }
        }

        if (!hasSmsAlerts || confirmation) {
          this.updateUser(user);
        }
      } else {
        this.updateUser(user);
      }
    },
    async updateUser(user) {
      this.loadingBtn = true;
      await API.user.updateContactInfo({ user });
      this.$store.dispatch('profiles/getUser', { userId: this.userId });
      this.$store.dispatch('profiles/getUserProfile');

      this.$store.dispatch('applications/setSuccessNotification', {
        message: 'User updated',
        timeout: 7000,
      });
      this.loadingBtn = false;
    },
    viewCompanyProfile(companyId) {
      this.$router.push(`/companies/${companyId}/profile`);
    },
  },
  created() {
    window.__insp.push(['tagSession', 'access_personal_profile']);
    this.$ga.event({
      eventCategory: 'open_section',
      eventAction: 'personal_profile',
    });
    this.$store.dispatch('applications/addLoading', [
      this.$store.dispatch('profiles/getUser', { userId: this.userId }),
    ]);
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/User/Profile.vue